import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { Code, Icon, Text, Heading } from '@scale/scaleui-radix';

interface TaskIdInfoProps {
  taskIdColumn: string;
}

export const TaskIdInfo = ({ taskIdColumn }: TaskIdInfoProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Heading size="2" weight="medium" className="text-gray-700">
        Task ID Column
      </Heading>
      <div className="flex items-center gap-2">
        <Icon icon={faCircleInfo} className="text-gray-500" label="Info" />
        <Text as="p" size="2" className="text-gray-600">
          Using column <Code>{taskIdColumn}</Code> to identify tasks
        </Text>
      </div>
    </div>
  );
};
